import { StylesProvider, jssPreset } from "@material-ui/core/styles";
import { create } from "jss";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter as Router } from "react-router-dom";
import "./themeV2";
import ThemeProvider from "./theme";

// global state
import { StateProvider } from "./globalState";
import TrackingProvider from "./services/TrackingProvider";

// services
import ChatLauncher from "./components/ChatLauncher/ChatLauncher";
import ShoppingCart from "./components/ShoppingCart";
import UrlNotice from "./components/UrlNotice";
import StaleReleaseReload from "./errors/StaleReleaseReload";
import Routes from "./Routes";
import Alerts from "./services/Alerts";
import BrowserWidth from "./services/BrowserWidth";
import CookieNotice from "./services/CookieNotice";
import EducationalModal from "./services/EducationalModal";
import GoogleAnalyticsProvider from "./services/GoogleAnalyticsProvider";
import PostHogProvider from "./services/PostHogProvider";
import NoScroll from "./services/NoScroll";
import NotificationProvider from "./services/Notifications";
import ProcessInjection from "./services/ProcessInjection";
import StartingShop from "./services/ActiveInfluencer";
import { capture } from "./services/posthogCapture";
import { JSS_SHEET_DETACHED } from "./services/posthogEvents";
import StoreLandingPageInLocalStorage from "./services/StoreLandingPageInLocalStorage";
import UserAuth from "./services/UserAuth";
import { guardRenderer } from "./theme/jss/guardedRenderer";

const baseJss = create(jssPreset());
const jss = baseJss.setup({
  Renderer: guardRenderer(baseJss.options.Renderer, {
    onDetached: () => capture(JSS_SHEET_DETACHED),
  }),
});

export default function App(props) {
  return (
    <HelmetProvider>
      <StylesProvider jss={jss}>
        <StateProvider>
          <ThemeProvider>
            <GoogleAnalyticsProvider>
              <PostHogProvider>
                <TrackingProvider>
                  <NotificationProvider>
                    <Router>
                      <Routes {...props} />

                      <EducationalModal />
                      <ShoppingCart />
                      <ChatLauncher />
                      <UrlNotice />
                      <StaleReleaseReload />
                    </Router>

                    <StoreLandingPageInLocalStorage />

                    <UserAuth />

                    <StartingShop />

                    <BrowserWidth />

                    <Alerts />

                    <ProcessInjection />

                    <CookieNotice />

                    <NoScroll />
                  </NotificationProvider>
                </TrackingProvider>
              </PostHogProvider>
            </GoogleAnalyticsProvider>
          </ThemeProvider>
        </StateProvider>
      </StylesProvider>
    </HelmetProvider>
  );
}
